import React, { useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
// eslint-disable-next-line import/no-extraneous-dependencies
import { MdDelete } from 'react-icons/md'
import { Formik, Form as FormikForm } from 'formik'
import { useDispatch, useSelector } from 'react-redux'
import useWalletFilters from '../useWalletFilters'
import * as reducks from '../../../../reducks'
import Text from '../../Text/Text'
import Flex from '../../Flex/Flex'
import Tag from '../../Tag/Tag'
import CheckboxMultFieldFormik from '../../Fields/CheckboxMultFieldFormik'
import SelectFieldFormik from '../../Fields/SelectFieldFormik'
import SelectMultFieldFormik from '../../Fields/SelectMultFieldFormik'
import Button from '../../Button/Button'
import Modal from '../../Modal/Modal'

/**
 * @TODO Itens a fazer ainda
 * @FIXME add use callback on handlers button
 */

export const VALID_FILTERS = ['storeStatus', 'storeGroups', 'products']

export const handleClear = async (valuesRef, resetFormRef, defaultRef = {}) => {
  if (!resetFormRef) return

  const newValues = {}

  Object.keys(valuesRef).forEach((field) => {
    newValues[field] = defaultRef[field] || []
  })

  resetFormRef({ values: newValues })
}

export const handleChange = (value, current = [], setValue) => {
  const currentItemIntex = current.findIndex((item) => item === value.id)
  const currentItem = current[currentItemIntex]
  const newValue = [...current]

  if (value.status) {
    if (currentItem) return

    newValue.push(value.id)
  } else {
    if (!currentItem) return

    newValue.splice(currentItemIntex, 1)
  }

  setValue({ priorityMatrices: newValue })
}

export const handleSubmit = async (data, closeCallback, dispatch) => {
  await dispatch(reducks.resources.wallet.actions.walletApplyFilters(data))
  closeCallback()
}

export const extractFilters = (filters) => ({
  storeStatus: filters.storeStatus,
  storeGroups: filters.storeGroups,
  products: filters.products,
  segments: filters.segments,
  priorityMatrices: filters.priorityMatrices
})

const ModalFilters = ({ filters, visible, closeCallback }) => {
  let resetFormRef
  let valuesRef

  const dispatch = useDispatch()

  const {
    canViewGroup,
    canViewProduct,
    canViewStatus,
    canGetSegmentsAndSubsegments,
    canViewPriorityMatrices
  } = useWalletFilters()

  useEffect(() => {
    if (canViewGroup)
      dispatch(reducks.resources.filters.actions.getStoreGroups())

    if (canViewProduct)
      dispatch(reducks.resources.filters.actions.getStoreProducts())

    if (canViewStatus)
      dispatch(reducks.resources.filters.actions.getStoreStatuses())

    if (canGetSegmentsAndSubsegments)
      dispatch(reducks.resources.filters.actions.getSegments())

    if (canViewPriorityMatrices)
      dispatch(reducks.resources.filters.actions.getPriorityMatrices())
  }, [])

  const { storeStatuses, storeGroups, products, priorityMatrices, segments } =
    useSelector((state) => state.filtersReducer)

  const [value, setValue] = useState({
    priorityMatrices: filters?.priorityMatrices
  })

  useEffect(() => {
    setValue({ priorityMatrices: filters?.priorityMatrices })
  }, [visible, filters?.priorityMatrices])

  const initialValues = useMemo(() => extractFilters(filters), [])

  useEffect(() => {
    resetFormRef({
      values: extractFilters(filters)
    })
  }, [visible])

  return (
    <Modal
      visible={visible}
      size="small"
      rounded
      onClickOverlay={closeCallback}
      HeaderContent={() => (
        <>
          <Text value="Filtros" size="md" color="gray" variation="dark" bold />
          <button
            type="button"
            onClick={() => {
              return handleClear(
                valuesRef,
                resetFormRef,
                reducks.resources.wallet.INITIAL_STATE.filters
              )
            }}
          >
            <Text
              value="Limpar"
              color="gray"
              variation="dark"
              size="xxs"
              margin="0px 5px 0px 0px"
            />
            <MdDelete color="#4D4D4D" size={15} />
          </button>
        </>
      )}
    >
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={(data) => handleSubmit(data, closeCallback, dispatch)}
      >
        {({ isSubmitting, isValid, values, resetForm }) => {
          const disabled = isSubmitting || !isValid

          resetFormRef = resetForm
          valuesRef = values

          return (
            <FormikForm>
              <>
                {canViewPriorityMatrices && (
                  <Flex wrap="wrap" margin="10px 0px">
                    {priorityMatrices.content.map((tag) => {
                      const isActive = value.priorityMatrices.includes(tag.id)
                      const transformedTag = {
                        id: tag.id,
                        status: !isActive
                      }

                      return (
                        <Tag
                          onClick={() => {
                            handleChange(
                              transformedTag,
                              value.priorityMatrices,
                              setValue
                            )
                          }}
                          key={tag.id}
                          id={tag.id}
                          active={isActive}
                          text={tag.name}
                          size="xxs"
                        />
                      )
                    })}
                  </Flex>
                )}

                {canViewStatus && (
                  <Flex column margin="40px 0px 24px">
                    <Text
                      value="Status"
                      size="sm"
                      color="gray"
                      variation="dark"
                      font="custom"
                      margin="0 0 24px"
                      bold
                    />

                    <CheckboxMultFieldFormik
                      name="storeStatus"
                      options={storeStatuses.content}
                      initialValues={filters.storeStatus}
                    />
                  </Flex>
                )}

                {canGetSegmentsAndSubsegments && (
                  <Flex column margin="24px 0px">
                    <Flex alignItems="center" justifyContent="space-between">
                      <Text
                        value="Segmento"
                        size="sm"
                        color="gray"
                        variation="dark"
                        font="custom"
                        bold
                      />

                      <Text
                        value="Limpar"
                        size="xxs"
                        color="gray"
                        variation="dark"
                        font="custom"
                        onClick={() => {
                          return resetForm({
                            values: { ...values, segments: [] }
                          })
                        }}
                        underline
                      />
                    </Flex>

                    <SelectFieldFormik
                      name="segments"
                      placeholder="Selecione o segmento"
                      options={segments.content}
                    />
                  </Flex>
                )}

                {canViewGroup && (
                  <Flex column margin="24px 0px">
                    <Flex alignItems="center" justifyContent="space-between">
                      <Text
                        value="Grupo"
                        size="sm"
                        color="gray"
                        variation="dark"
                        font="custom"
                        bold
                      />

                      <Text
                        value="Limpar"
                        size="xxs"
                        color="gray"
                        variation="dark"
                        font="custom"
                        onClick={() => {
                          return resetForm({
                            values: { ...values, storeGroups: [] }
                          })
                        }}
                        underline
                      />
                    </Flex>

                    <SelectFieldFormik
                      name="storeGroups"
                      placeholder="Selecione o grupo de lojas"
                      options={storeGroups.content}
                    />
                  </Flex>
                )}

                {canViewProduct && (
                  <Flex column margin="24px 0px">
                    <Flex alignItems="center" justifyContent="space-between">
                      <Text
                        value="Produtos"
                        size="sm"
                        color="gray"
                        variation="dark"
                        font="custom"
                        bold
                      />

                      <Text
                        value="Limpar"
                        size="xxs"
                        color="gray"
                        variation="dark"
                        font="custom"
                        onClick={() => {
                          return resetForm({
                            values: { ...values, products: [] }
                          })
                        }}
                        underline
                      />
                    </Flex>

                    <SelectMultFieldFormik
                      name="products"
                      placeholder="Selecione os produtos"
                      options={products.content}
                    />
                  </Flex>
                )}

                <Flex
                  alignItems="center"
                  justifyContent="center"
                  margin="30px 0px"
                >
                  <Button
                    width="234px"
                    type="secondary"
                    buttonType="submit"
                    disabled={disabled}
                  >
                    Ver Resultado
                  </Button>
                </Flex>
              </>
            </FormikForm>
          )
        }}
      </Formik>
    </Modal>
  )
}

ModalFilters.defaultProps = {
  visible: true
}

ModalFilters.propTypes = {
  visible: PropTypes.bool,
  closeCallback: PropTypes.func.isRequired,
  filters: PropTypes.shape({
    storeStatus: PropTypes.array,
    storeGroups: PropTypes.array,
    products: PropTypes.array,
    networkCodes: PropTypes.array,
    subsidiaryCodes: PropTypes.array,
    partnerStdCodes: PropTypes.array,
    priorityMatrices: PropTypes.array,
    segments: PropTypes.array,
    subsegments: PropTypes.array,
    orderBy: undefined
  }).isRequired
}

export default ModalFilters
